module.exports = __webpack_public_path__ + "static/media/SFW205GQC1.75b0865d.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/callouts/SFW205GQC1.png
// module id = 1029
// module chunks = 0